<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

import LayoutValidation from '@layouts/LayoutValidation.vue';
import BaseFileUpload from '@components/base/BaseFileUpload.vue';
import { XIcon, XButton } from '@clicksign/excalibur';
import { sendEvent } from '@utils/analytics';

const store = useStore();
const { t } = useI18n();

const isResignedDocument = ref(false);

const documentFile = computed(() => store.state.fileUpload.document);

function downloadFile() {
  const url = window.URL.createObjectURL(new Blob([documentFile.value.data]));

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', documentFile.value.name);

  document.body.appendChild(link);

  link.click();

  sendEvent({
    eventCategory: 'document-validator-p7s',
    eventAction: 'button-download-click',
  });
}
</script>

<template>
  <LayoutValidation
    icon="file-lines"
    color="var(--color-brand-support-01-500)"
    container-width="480px"
  >
    <template #title>
      {{ t('cadesSignature.default.title') }}
    </template>

    <template #description>
      <p>{{ t('cadesSignature.default.description') }}</p>
    </template>

    <template #action>
      <BaseFileUpload
        v-if="!isResignedDocument"
        is-renew
        :path="'/cades_signature/sign'"
        :loading-text="t('validator.document.loading')"
        @document-resigned="isResignedDocument = true"
      />

      <XButton
        v-else
        @click="downloadFile()"
      >
        <XIcon
          icon="arrow-down-to-line"
          left
        />
        {{ t('renewCertificate.finished.button') }}
      </XButton>
    </template>
  </LayoutValidation>
</template>

<style module></style>
